// 英语
export const GUIDES = [
  { name: 'guide-overview', title: 'Overview', groupIndex: 0 },
  { name: 'guide-account', title: 'About Account', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'About the vehicle', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Set up the dashboard', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Set up the vehicle ', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Find the vehicle', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Navigation', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'About Ride History', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Inspection', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'APP settings', groupIndex: 3 },
  { name: 'guide-notice', title: 'View and set message notification', groupIndex: 3 },
  { name: 'guide-about', title: 'About APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Pending',
  1: 'No reply',
  2: 'Replied',
  3: 'in communication',
  4: 'countermeasures',
  5: 'solved',
};

export const FEEDBACK_TYPES = {
  1: 'Feedback',
  2: 'Reply',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
